module.exports = __webpack_public_path__ + "static/media/Ø3(1).13a63e5e.png";